const translation = {
  toVerifiedTip: {
    end: 'для професійного плану Dify.',
    coupon: 'ексклюзивний купон 100%',
    front: 'Ви тепер маєте право на статус перевіреної освіти. Будь ласка, введіть свою інформацію про освіту нижче, щоб завершити процес і отримати',
  },
  form: {
    schoolName: {
      title: 'Ваша назва школи',
      placeholder: 'Введіть офіційну, повну назву вашої школи',
    },
    schoolRole: {
      option: {
        administrator: 'Шкільний адміністратор',
        teacher: 'Вчитель',
        student: 'Студент',
      },
      title: 'Ваша роль у школі',
    },
    terms: {
      desc: {
        and: 'і',
        end: '. Надсилаючи:',
        privacyPolicy: 'Політика конфіденційності',
        termsOfService: 'Умови обслуговування',
        front: 'Ваша інформація та використання статусу Перевірено в освіті підлягають нашому',
      },
      option: {
        inSchool: 'Я підтверджую, що я зареєстрований або працюю в зазначеній установі. Dify може вимагати підтвердження моєї реєстрації/трудової зайнятості. Якщо я неправильно представлю свою кваліфікацію, я погоджуюся сплатити будь-які збори, які спочатку були скасовані на основі мого навчального статусу.',
        age: 'Я підтверджую, що мені щонайменше 18 років.',
      },
      title: 'Умови та угоди',
    },
  },
  submitError: 'Відправка форми не вдалася. Будь ласка, спробуйте ще раз пізніше.',
  rejectTitle: 'Ваша перевірка освіти Dify була відхилена',
  submit: 'Надіслати',
  successTitle: 'Ви отримали перевірене освіту Dify',
  emailLabel: 'Ваш поточний електронний лист',
  rejectContent: 'На жаль, ви не відповідаєте вимогам для статусу Education Verified і тому не можете отримати ексклюзивний купон на 100% для професійного плану Dify, якщо використовуєте цю електронну адресу.',
  toVerified: 'Отримайте підтвердження освіти',
  learn: 'Дізнайтеся, як перевірити освіту',
  currentSigned: 'В даний момент ви підписані як',
  successContent: 'Ми видали купон на 100% знижку на професійний план Dify для вашого акаунту. Купон дійсний протягом одного року, будь ласка, скористайтеся ним протягом терміну дії.',
}

export default translation
